import { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
} from "react-router-dom";
// import { HelmetProvider } from "react-helmet-async";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Community from "./pages/Community";
import Contact from "./pages/Contact";
import Careers from "./pages/Careers";
import JobApplication from "./pages/JobApplication";
import NotFound from "./pages/NotFound";
import PDFViewer from "./pages/hidden/Handbook/Saftey/PdfViewer";
import Handbooks from "./pages/hidden/Handbook/Handbooks";

// hidden links

import { Link } from "react-router-dom";

function HiddenLinksForReactSnap() {
  return (
    <div style={{ display: "none" }}>
      <Link to="/">Home</Link>
      <Link to="/community">Community</Link>
      <Link to="/contact">Contact</Link>
      <Link to="/careers">Careers</Link>
    </div>
  );
}

export function App() {
  const [selectedItems, setSelectedItems] = useState("Home");

  // layout that wraps the normal pages with navbar/footer
  function MainLayout() {
    return (
      <>
        <Navbar
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
        />

        <main>
          <Outlet />
        </main>

        <Footer />
      </>
    );
  }

  return (
    // <HelmetProvider>
    <Router>
      {/* for react-snap / pre-renderer */}
      <HiddenLinksForReactSnap />

      <Routes>
        {/* pages that should render with the Navbar and Footer */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/community" element={<Community />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />

          <Route path="/job-application" element={<JobApplication />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        {/* this route will render without Navbar/Footer */}
        <Route path="/handbooks" element={<Handbooks />} />
        <Route path="/handbook-pdf" element={<PDFViewer />} />
      </Routes>
    </Router>
    // </HelmetProvider>
  );
}

export default App;
